var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 1.16699L12.8327 3.50033M1.16602 12.8337L1.91058 10.1036C1.95916 9.92546 1.98345 9.83641 2.02073 9.75336C2.05384 9.67962 2.09452 9.60952 2.14212 9.54419C2.19572 9.47062 2.261 9.40534 2.39154 9.2748L8.41937 3.24698C8.53487 3.13147 8.59262 3.07372 8.65922 3.05208C8.7178 3.03305 8.7809 3.03305 8.83948 3.05208C8.90608 3.07372 8.96383 3.13147 9.07933 3.24698L10.7527 4.92034C10.8682 5.03585 10.926 5.0936 10.9476 5.1602C10.9666 5.21878 10.9666 5.28188 10.9476 5.34046C10.926 5.40705 10.8682 5.4648 10.7527 5.58031L4.72488 11.6081C4.59433 11.7387 4.52906 11.804 4.45548 11.8576C4.39015 11.9052 4.32005 11.9458 4.24632 11.9789C4.16327 12.0162 4.07421 12.0405 3.8961 12.0891L1.16602 12.8337Z",
    stroke: "#2B144D",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilPurple);
export default __webpack_public_path__ + "static/media/pencil_purple.795fc81950208cc706d25cd0bd4e3906.svg";
export { ForwardRef as ReactComponent };